import { ModelMixin } from '@models/core/base-generic.model';

export class IncomeTypeRequest extends ModelMixin<IncomeTypeRequest>() {
    protected static _resource = 'payroll/companies/:company/additionalIncomes/requestCustom';

    protected static _version = 'v2';

    protected static _serializeAttributes = [
        'name',
        'description',
        'taxable',
        'pensionable',
        'insurable',
        'vacationable',
        't4Boxes',
        'rl1Boxes',
        'assessable',
        'has_hours',
        'multiplier',
        'recurrable',
        'periodic',
        'eptable',
    ];

    get name(): string {
        return this._attributes['name'];
    }

    set name(value: string) {
        this._attributes['name'] = value;
    }

    get description(): string {
        return this._attributes['description'];
    }

    set description(value: string) {
        this._attributes['description'] = value;
    }

    get taxable(): boolean {
        return this._attributes['taxable'];
    }

    set taxable(value: boolean) {
        this._attributes['taxable'] = value;
    }

    get pensionable(): boolean {
        return this._attributes['pensionable'];
    }

    set pensionable(value: boolean) {
        this._attributes['pensionable'] = value;
    }

    get insurable(): boolean {
        return this._attributes['insurable'];
    }

    set insurable(value: boolean) {
        this._attributes['insurable'] = value;
    }

    get vacationable(): boolean {
        return this._attributes['vacationable'];
    }

    set vacationable(value: boolean) {
        this._attributes['vacationable'] = value;
    }

    get assessable(): boolean {
        return this._attributes['assessable'];
    }

    set assessable(value: boolean) {
        this._attributes['assessable'] = value;
    }

    get t4Boxes(): number[] {
        return this._attributes['t4Boxes'];
    }

    set t4Boxes(value: number[]) {
        this._attributes['t4Boxes'] = value;
    }

    get rl1Boxes(): string[] {
        return this._attributes['rl1Boxes'];
    }

    set rl1Boxes(value: string[]) {
        this._attributes['rl1Boxes'] = value;
    }

    get hasHours(): boolean {
        return this._attributes['has_hours'];
    }

    set hasHours(value: boolean) {
        this._attributes['has_hours'] = value;
    }

    get multiplier(): number {
        return this._attributes['multiplier'];
    }

    set multiplier(value: number) {
        this._attributes['multiplier'] = value;
    }

    get recurrable(): boolean {
        return this._attributes['recurrable'];
    }

    set recurrable(value: boolean) {
        this._attributes['recurrable'] = value;
    }

    get periodic(): boolean {
        return this._attributes['periodic'];
    }

    set periodic(value: boolean) {
        this._attributes['periodic'] = value;
    }

    get bonusTax(): boolean {
        return !this._attributes['periodic'];
    }

    set bonusTax(value: boolean) {
        this._attributes['periodic'] = !value;
    }

    get eptable(): boolean {
        return this._attributes['eptable'];
    }

    set eptable(value: boolean) {
        this._attributes['eptable'] = value;
    }
}
